<!-- <h1 mat-dialog-title>¿Deseas realizar esta acción?</h1>
<div mat-dialog-content>
  {{data.message}}
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="false" tabindex="-1" color="warn">No</button>
  <button mat-raised-button  (click)="onConfirmClick()" tabindex="1" color="primary">Si</button>
</div> -->


 <!-- Modal -->
 <div x-show="showModal" x-transition:enter="transition ease-out duration-300 transform" x-transition:enter-start="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" x-transition:enter-end="opacity-100 translate-y-0 sm:scale-100" x-transition:leave="transition ease-in duration-200 transform" x-transition:leave-start="opacity-100 translate-y-0 sm:scale-100" x-transition:leave-end="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" class="fixed z-10 inset-0 overflow-y-auto" x-cloak>
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <!-- Modal panel -->
    <div class="w-full inline-block align-bottom bg-white/50 backdrop-blur-xl z-20 max-w-xl  right-5 top-5  p-6  rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <!-- Modal content -->
        <div class="sm:flex sm:items-start">
          <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full  sm:mx-0 sm:h-10 sm:w-10">
            <!-- Heroicon name: outline/exclamation -->
            <img src="../../../../../assets/img/favicon1.png"  class="h-full w-full object-cover object-center sm:h-full sm:w-full">

          </div>
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline"> ¿Deseas realizar esta acción?</h3>
            <div class="mt-2">
              <p class="text-sm text-gray-500"> {{data.message}}</p>
            </div>
          </div>
        </div>
        <div class=" px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <button  (click)="onConfirmClick()" tabindex="1"  type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-orange-500 text-base font-medium text-white hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 sm:ml-3 sm:w-auto sm:text-sm"> Confirmar </button>
          <button [mat-dialog-close]="false" tabindex="-1" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"> Cancelar </button>
        </div>
      </div>
      
    </div>
  </div>
